import { IntervalDataEntry } from '../useActiveManagementApi/types'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const generateAggregatedIntervalDataResponse =
    (): IntervalDataEntry[] => {
        const response: IntervalDataEntry[] = []
        const startDate = dayjs.utc('2024-01-01T00:00:00Z')
        const daysToGenerate = 14 // 2 weeks
        const intervalMinutes = 15
        const hoursPerDay = 24
        const intervalsPerDay = (hoursPerDay * 60) / intervalMinutes // 96 intervals per day

        // Base values for generating realistic variations
        const baseUsage = 120
        const baseDemandMax = 60
        const baseDemandAverage = 58

        for (let day = 0; day < daysToGenerate; day++) {
            const currentDate = startDate.add(day, 'day')

            for (let interval = 0; interval < intervalsPerDay; interval++) {
                const utcTime = currentDate
                    .startOf('day')
                    .add(interval * intervalMinutes, 'minute')
                const localTime = utcTime.subtract(5, 'hour') // EST timezone offset

                // Generate some variation in values
                // Simulate daily patterns (lower at night, higher during day)
                const hourOfDay = (interval * intervalMinutes) / 60
                const dayMultiplier =
                    0.7 + (Math.sin(((hourOfDay - 6) * Math.PI) / 12) + 1) * 0.3
                const randomVariation = 0.85 + Math.random() * 0.3 // 0.85 to 1.15

                const usage =
                    Math.round(
                        baseUsage * dayMultiplier * randomVariation * 100
                    ) / 100
                const demandMax =
                    Math.round(
                        baseDemandMax * dayMultiplier * randomVariation * 100
                    ) / 100
                const demandAverage =
                    Math.round(
                        baseDemandAverage *
                            dayMultiplier *
                            randomVariation *
                            100
                    ) / 100

                response.push({
                    date: utcTime.toISOString(),
                    usage,
                    demandMax,
                    demandAverage,
                    timestampLocal: localTime.format('YYYY-MM-DDTHH:mm:ssZ'),
                    reportedMeters: 19,
                })
            }
        }

        return response
    }
